"use client";

import Link from "next/link";
import { RiGridFill, RiListCheck } from "react-icons/ri";
import { Tabs, TabsList, TabsTrigger } from "~/components/shadcn/Tabs";
import { cn } from "~/utils/fontsConfig";

export const TabSwitcher = ({
    communitySlug,
    tab,
    className,
}: {
    communitySlug: string;
    tab?: string;
    className?: string;
}) => {
    return (
        <div className={cn("mt-6", className)}>
            <Tabs defaultValue="image-overlays">
                <TabsList className="w-full justify-start rounded-none border-b-[1px] border-b-v3-N-500 bg-none p-0">
                    <TabsTrigger
                        className={cn(
                            "rounded-none py-2 opacity-50 ",
                            tab !== "calendar-view" &&
                                "border-b-[2px] border-b-v3-clover bg-inherit opacity-100",
                        )}
                        value=""
                    >
                        <Link
                            href={{
                                pathname: `/${communitySlug}`,
                                query: { tab: "events-view" },
                            }}
                        >
                            Events View
                        </Link>
                    </TabsTrigger>

                    <TabsTrigger
                        className={cn(
                            "rounded-none py-2 opacity-50 ",
                            tab === "calendar-view" &&
                                "border-b-[2px] border-b-v3-clover bg-inherit opacity-100",
                        )}
                        value="calendar-view"
                    >
                        <Link
                            href={{
                                pathname: `/${communitySlug}`,
                                query: { tab: "calendar-view" },
                            }}
                        >
                            Calendar View
                        </Link>
                    </TabsTrigger>
                </TabsList>
            </Tabs>
        </div>
    );
};

const BUTTON_CLASS_NAMES = cn(
    "bg-transparent text-xl text-v3-light-gray",
    "leading-1 min-w-max",
    "hover:white rounded hover:ring-2 disabled:bg-v3-N-200 disabled:text-v3-N-300",
    "p-2 ring-offset-background ring-v3-N-400",
);

export const TabSwitcherIcons = ({
    communitySlug,
    className,
    tab,
}: {
    communitySlug: string;
    className?: string;
    tab: "events-view" | "calendar-view";
}) => {
    return (
        <div
            className={cn(
                className,
                "flex gap-2",
                " rounded-md bg-v3-neutral p-1",
            )}
        >
            <Link
                href={{
                    pathname: `/${communitySlug}`,
                    query: { tab: "events-view" },
                }}
                className={cn(
                    BUTTON_CLASS_NAMES,
                    tab === "events-view" && "bg-white text-black",
                )}
            >
                <RiGridFill />
            </Link>

            <Link
                href={{
                    pathname: `/${communitySlug}`,
                    query: { tab: "calendar-view" },
                }}
                className={cn(
                    BUTTON_CLASS_NAMES,
                    tab === "calendar-view" && "bg-white text-black",
                )}
            >
                <RiListCheck />
            </Link>
        </div>
    );
};
